import { AdminDashboard } from '@/components/admin/AdminDashboard'

export function Admin() {
  return <AdminDashboard />
}
